module.exports = __webpack_public_path__ + "img/mod_3.d03e1973.png";